<template>
  <div
    :id="id"
    class="roomie-toast"
    :class="setClasses">
    <div class="roomie-toast__container">
      <RoomieIcon>
        <SuccessIcon v-if="variant === 'success'" />
        <ErrorIcon v-if="variant === 'error'" />
        <WarningIcon v-if="variant === 'warning'" />
        <InfoIcon v-if="variant === 'info'" />
      </RoomieIcon>

      <div class="roomie-toast__info">
        <div>
          <p class="roomie-toast__title font-regular">
            {{ title }}
          </p>
        </div>
        <div class="roomie-toast__content">
          <p class="roomie-toast__description">
            {{ description }}
          </p>
          <a
            target="_blank"
            class="roomie-toast__link underline"
            :style="{color: currentColor}"
            rel="noopener"
            :href="linkUrl">
            {{ linkText }}
          </a>
          <slot name="content" />
        </div>
      </div>

      <RoomieNavigationButton
        id="roomie-navigation-button"
        class="roomie-toast__button"
        size="sm"
        variant="ghost"
        @click="closeToast">
        <CloseIcon :style="{fill: currentColor}" />
      </RoomieNavigationButton>
    </div>
  </div>
</template>

<script>
import RoomieNavigationButton from '../RoomieNavigationButton/index.vue'
import CloseIcon from '../../assets/icons/close.svg'
import SuccessIcon from '../../assets/icons/success.svg'
import WarningIcon from '../../assets/icons/warning.svg'
import ErrorIcon from '../../assets/icons/error.svg'
import InfoIcon from '../../assets/icons/info.svg'
import RoomieIcon from '../RoomieIcon/index.vue'

export { VARIANT } from './utils'

export default {
  name: 'RoomieToast',
  components: {
    RoomieNavigationButton,
    CloseIcon,
    RoomieIcon,
    SuccessIcon,
    WarningIcon,
    ErrorIcon,
    InfoIcon
  },
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    linkText: {
      type: String,
      default: ''
    },
    linkUrl: {
      type: String,
      default: ''
    },
    timeToHide: {
      type: Number,
      default: 5000
    },
    isVisible: {
      type: Boolean,
      default: false,
      required: false
    },
    variant: {
      type: String,
      default: 'success',
      validator: (value) => ['success', 'error', 'warning', 'info'].includes(value),
      required: true
    }
  },
  data () {
    return {
      colors: {
        'success': '#0a4e3f',
        'error': '#6d0606',
        'warning': '#bb8100',
        'info': '#003879'
      },
      currentColor: ''
    }
  },
  computed: {
    setClasses() {
      return {
        'non-visible': !this.isVisible,
        'visible': this.isVisible,
        'roomie-toast--success': this.variant === 'success',
        'roomie-toast--error': this.variant === 'error',
        'roomie-toast--warning': this.variant === 'warning',
        'roomie-toast--info': this.variant === 'info'
      }
    },
  },
  mounted () {
    this.currentColor = this.colors[this.variant]
    setTimeout(() => {
      this.closeToast()
    }, this.timeToHide)
  },
  methods: {
    closeToast () {
      this.$emit('toast-closed')
    }
  }
}
</script>

<style
  lang="scss"
  src="./_index.scss">
</style>
